export default __webpack_public_path__ + "dfe24e95a2d71a27ab885a351fa2c41b.svg";